import { addBreadcrumb, captureException, captureMessage, withScope } from '@sentry/nextjs';

import { IOC } from '@/ioc/index';

import { isNotFoundAxiosError } from './axios';

import type { Breadcrumb, SeverityLevel } from '@sentry/nextjs';

export function logMessage(message: string, level: SeverityLevel = 'info') {
  if (IOC.get('ClientEnvVars').isSentryEnabled) {
    captureMessage(message, level);
  }
}

export function logBreadcrumb(breadcrumb: Breadcrumb) {
  if (IOC.get('ClientEnvVars').isSentryEnabled) {
    addBreadcrumb(breadcrumb);
  }
}

export function logError(message: string, data: unknown = undefined) {
  if (IOC.get('ClientEnvVars').isSentryEnabled) {
    withScope(function (scope) {
      if (data) {
        scope.setExtra('data', data);
      }
      captureMessage(message, 'error');
    });
  }
}

export function logException(key: string, error: unknown) {
  if (IOC.get('ClientEnvVars').isSentryEnabled && !isNotFoundAxiosError(error)) {
    withScope(function (scope) {
      scope.addEventProcessor((event) => {
        if (event.exception?.values) {
          const currentException = event.exception.values[0];
          currentException.value = `${currentException.type}: ${currentException.value}`;
          currentException.type = key;
        } else {
          event.transaction = key;
        }
        return event;
      });

      captureException(error);
    });
  } else {
    console.error(key, error);
  }
}
